export const GET_BANK_CHOICE_CHIPS = "GET_BANK_CHOICE_CHIPS";